import React, { useRef } from "react";
import FloatingWindow from "../../genericComponents/FloatingWindow/FloatingWindow";
import { setNauticalImageContext } from "../../../store/appSlice";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../../store/rootReducer";
import "./NauticalImageWindow.css";

const NauticalImageWindow: React.FC = () => {
    const imageContainerRef = useRef(document.createElement("div"));
    const dispatch = useDispatch();
    const nauticalImageContext = useSelector((state: StoreState) => state.app.nauticalImageContext);

    if (!nauticalImageContext.open) {
        return null;
    }

    return (
        <FloatingWindow
            closeWindow={() => dispatch(setNauticalImageContext({ open: false, sjomerkeNr: null, imageUrl: null }))}
            toolRef={imageContainerRef}
            title={`Nautisk bilde for ${nauticalImageContext?.sjomerkeNr}`}
            className="nauticalimage-floating-window-container"
            contentClassName="nauticalimage-floating-window-content"
            defaultPosition={{ x: 360, y: 0 }}
            width={window.innerWidth - 400}
        >
            <img
                src={nauticalImageContext?.imageUrl}
                alt={`Nautisk bilde for ${nauticalImageContext?.sjomerkeNr}`}
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    display: "block",
                    objectFit: "contain",
                }}
            />
        </FloatingWindow>
    );
};

export default NauticalImageWindow;
